import { createFileRoute } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";

export const Route = createFileRoute("/blog")({
  loader: () => loadContentPage("/blog"),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});
function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
